import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import MultipleFileUpload from "app/views/custom/components/FileUpload/MultipleFileUpload";
import { getCapaById, updateCapa } from "app/_services/ehs/ehsCapaServices";
import { Validation } from "app/_helpers/validation/Validation";
import {
  capaUpdateRules,
  FORM_LABEL_OFFICER,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { initialCapa, capaPriorities } from "../IncidentManagement/CONSTANTS";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { CommmonService } from "app/_services/CommonService/CommonService";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { disableFutureDate } from "app/_helpers/dateHelper";
import IncidentTimeline from "../IncidentManagement/IncidentTimeline";
import VFLTimeline from "../VFL/component/VFLTimeline";
import { getIncidentReportById } from "app/_services/ehs/ehsIncidentServices";
import { getVFLByID } from "app/_services/ehs/VFLService";
import ViewCommentsComponent from "../IncidentManagement/ViewCommentsComponent";
import { VFL_STATUS } from "../VFL/CONSTANTS";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import YesOrNo from "../YesOrNo.component";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const UpdateCapa = ({
  match: {
    params: { id, siteId },
  },
  history,
}) => {
  const [tab, setTab] = useState(2);
  const [form, setForm] = useState({ ...initialCapa, closed: false });
  const [errorForm, setErrorForm] = useState({
    ...initialCapa,
    source: "",
    capaStatus: "",
  });
  const [incidentVflDetails, setIncidentVflDetails] = useState({});
  const [capaComments, setCapaComments] = useState([]);
  const [subArea, setSubArea] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChange = ({ target: { name, type, checked, value } }) =>
    setForm((prev) => {
      if (name === "capaStatus" && checked === true) {
        checked = "Completed";
      } else checked = "Open";
      return { ...prev, [name]: type === "checkbox" ? checked : value };
    });

  const onSubmit = CommmonService.debounce(async () => {
    let errObj = Validation(form, capaUpdateRules);
    errObj = form?.capaStatus == "Open" ? { ...errObj, completionDate: "" } : errObj;

    setErrorForm(errObj);

    for (const key in errObj) if (errObj[key]) return;
    setLoading(true);
    // console.log("/*/*/*/*/*capaUpdateRules", errObj);
    // return;
    const response = await updateCapa(id, form);

    setLoading(false);
    if (!response?.status) return toastr.error(response?.message);

    toastr.success("Success");
    history.goBack();
    // history.push((siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/capa-management/manage-capa");
  }, 1500);

  const onFileChange = (_event, responseData) => {
    setForm((prev) => ({
      ...prev,
      completionProofId: responseData.id,
      completionProof: responseData,
    }));
  };
  const deleteDocumentFile = (_event, _index) => {
    setForm((prev) => ({ ...prev, completionProofId: null, completionProof: null }));
  };

  useEffect(() => {
    getCapaById(id).then((response) => {
      if (!response?.data) return;

      setForm({ ...response.data, closed: response.data.capaStatus === "Closed" });

      if (response?.data?.source === "Incident Management") {
        getIncidentReportById(response?.data?.incidentDetailsId, "role=reviewer").then(
          (details) => {
            if (!details?.data) return;

            setIncidentVflDetails((prev) => {
              return {
                ...details.data,
                rootCauseAnalysisRequired: details.data.investigationDetails
                  ?.rootCauseAnalysisRequired
                  ? true
                  : false,
              };
            });

            setCapaComments(
              details?.data?.capas?.find((obj) => obj.id === response?.data?.id)
                ?.ehs_capa_reviews
            );
          }
        );
      } else {
        getVFLByID(response?.data?.incidentDetailsData?.vflId).then((details) => {
          if (!details?.data) return;

          setIncidentVflDetails({
            ...details.data,
          });

          setCapaComments(
            details?.data?.vflObservations
              ?.find((o) => o.allCapa?.find((k) => k.id === response?.data?.id))
              ?.allCapa.find((p) => p.id === response?.data?.id)?.ehs_capa_reviews
          );
        });
      }
    });
  }, [id]);

  useEffect(() => {
    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      const subAreaObj = response.data.find((d) => d.id === form?.workArea?.id);
      setSubArea(subAreaObj?.subAreaOfOperation || []);
    });
  }, [form?.workArea?.id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "CAPA Management",
            path: "/health-safety-and-environment/capa-management",
          },
          {
            name: "Manage CAPA",
            path: "/health-safety-and-environment/capa-management/manage-capa",
          },
          {
            name: "Edit",
          },
        ]}
      />
      {/* <Breadcrumb
        routeSegments={[
          { name: "Health Safety And Environment" },
          { name: "Manage CAPA", path: (siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/capa-management/manage-capa" },
          { name: "Update CAPA" },
        ]}
      /> */}
      <div className="healthSafetyEnvironmentWrapper lrgTabberWrapper mb-3">
        <div className="hseMenuLinks card">
          <a
            href
            onClick={() => setTab(1)}
            className={`pointer${tab === 1 ? " active" : ""}`}
          >
            Timeline
          </a>
          <a
            href
            onClick={() => setTab(2)}
            className={`pointer${tab === 2 ? " active" : ""}`}
          >
            CAPA
          </a>
          {capaComments?.length ? (
            <a
              href
              onClick={() => setTab(3)}
              // style={{pointerEvents: 'none'}}
              className={`pointer${tab === 3 ? " active" : ""}`}
            >
              Workflow Inputs
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      {tab === 1 && (
        <Col lg={12}>
          {form?.source === "Incident Management" ? (
            <IncidentTimeline
              reportDate={incidentVflDetails.reportDate}
              reporter={incidentVflDetails.reporter}
              investigationCompletionDate={incidentVflDetails.investigationCompletionDate}
              reviewCompletionDate={incidentVflDetails.reviewCompletionDate}
              investigationDetails={incidentVflDetails?.investigationDetails}
              reviewer={incidentVflDetails.reviewer}
              closer={incidentVflDetails.closer}
              personalDetails={incidentVflDetails.personalDetails}
              vehicleDetails={incidentVflDetails.vehicleDetails}
              assetDetails={incidentVflDetails.assetDetails}
              spills={incidentVflDetails.spills}
              //evidences={evidences}
              investigationCompleted={incidentVflDetails.investigationCompleted}
              reviewCompleted={incidentVflDetails.reviewCompleted}
              closureCompleted={incidentVflDetails.closureCompleted}
              isAssetIncident={incidentVflDetails.isAssetIncident}
              isPersonalInjury={incidentVflDetails.isPersonalInjury}
              isSpillsIncident={incidentVflDetails.isSpillsIncident}
              isVehicleIncident={incidentVflDetails.isVehicleIncident}
              closureCompletionDate={incidentVflDetails.closureCompletionDate}
              incidentStatus={incidentVflDetails.incidentStatus}
              insuranceApplicable={incidentVflDetails.insuranceApplicable}
              complianceRequired={incidentVflDetails.complianceRequired}
              trainingRequired={incidentVflDetails.trainingRequired}
              witnessStatementRequired={incidentVflDetails.witnessStatementRequired}
              rootCauseAnalysisRequired={incidentVflDetails.rootCauseAnalysisRequired}
              solutionRequired={incidentVflDetails.solutionRequired}
              capaRequired={incidentVflDetails.capaRequired}
              reportEvidencesRequired={incidentVflDetails.reportEvidencesRequired}
              evidencesRequired={incidentVflDetails.evidencesRequired}
              reviewEvidencesRequired={incidentVflDetails.reviewEvidencesRequired}
              incidentId={incidentVflDetails.incidentId}
              incidentDate={incidentVflDetails.incidentDate}
              type={incidentVflDetails.type}
              severity={incidentVflDetails.severity}
              severityPostReview={incidentVflDetails.severityPostReview}
              workArea={incidentVflDetails.workArea}
              site={incidentVflDetails.site}
              department={incidentVflDetails.department}
              isCapaPresent={
                incidentVflDetails.capas ? incidentVflDetails.capas.length : 0
              }
              capaCompletionDate={incidentVflDetails?.capaCompletionDate}
              capaCompletedByData={incidentVflDetails?.capaCompletedByData}
              finalReviewedByDate={incidentVflDetails?.finalReviewedByDate}
              finalReviewedByData={incidentVflDetails?.finalReviewedByData}
              reviewedByMMDate={incidentVflDetails?.reviewedByMMDate}
              reviewedByMMData={incidentVflDetails?.reviewedByMMData}
              reviewedDate={incidentVflDetails?.reviewedDate}
              staffData={incidentVflDetails?.staffData}
              staffType={incidentVflDetails?.staffType}
              otherStaffName={incidentVflDetails?.otherStaffName}
              area={incidentVflDetails?.area}
              capasList={incidentVflDetails?.capas}
              reportAtLabel={FORM_LABEL_OFFICER[incidentVflDetails?.reportAtLabel]}
              capaTimeLine
              form={incidentVflDetails}
            />
          ) : (
            <VFLTimeline form={incidentVflDetails} capaTimeLine />
          )}
        </Col>
      )}
      {tab === 2 && (
        <div className="card p-3 mt-4 overflow-inherit">
          <div className="simple-card-title title-overflowInherit">
            <h3 class="text-capitalize mb-0">Details</h3>
          </div>
          <div className="ehsFormWrapper">
            <Row>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Location Name - Location ID</h5>
                  <p>
                    {form.site?.name} {form.site?.siteId}
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Source Type</h5>
                  <p>{form.source === "ehs_vfl_observations" ? "VFL" : form.source}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">
                    {form?.source === "Incident Management" ? "Incident" : "VFL"} ID
                  </h5>
                  {form?.source === "Incident Management" ? (
                    <Link
                      to={
                        "/health-safety-and-environment/incident-management/review/view/" +
                        incidentVflDetails.id
                      }
                      target="_blank"
                      className=""
                    >
                      <p>{incidentVflDetails?.incidentId}</p>
                    </Link>
                  ) : (
                    <Link
                      to={
                        incidentVflDetails.vflStatus === VFL_STATUS.completed
                          ? "/health-safety-and-environment/vfl/completion/view/" +
                            incidentVflDetails.id
                          : "/health-safety-and-environment/vfl/view/" +
                            incidentVflDetails.id
                      }
                      target="_blank"
                      className=""
                    >
                      <p>{incidentVflDetails?.vflId}</p>
                    </Link>
                  )}
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">CAPA ID</h5>
                  <p>{form.capaId}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Source Area</h5>
                  <p>{form.workArea?.name}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Sub Area</h5>
                  <p>
                    {form?.subAreaId === 999
                      ? "Other"
                      : subArea.find((d) => d.id === form?.subAreaId)?.name}
                  </p>
                </div>
              </Col>
              {form?.subAreaId === 999 && (
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Other Sub Area</h5>
                    <p>{form.otherSubArea}</p>
                  </div>
                </Col>
              )}
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">CAPA Owner</h5>
                  <p>{userDropdownLabel(form.owner)}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Priority</h5>
                  <p>{capaPriorities[form.priority]}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Due Date</h5>
                  <p>{formatDDMMYYYYbyYYYYMMDD(form.dueDate)}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500 mb-1">Created Date</h5>
                  <p>{formatDDMMYYYYbyYYYYMMDD(form.createdAt)}</p>
                </div>
              </Col>
              <Col lg={8}>
                <div className="form-group viewbox">
                  <h5 className="w-500 mb-1">CAPA Description</h5>
                  <p>{form.solution}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500 mb-1">Completed</h5>
                  <div className="">
                    <YesOrNo
                      title={""}
                      name="capaStatus"
                      value={form?.capaStatus === "Completed" ? true : false}
                      onChange={onChange}
                      acceptTitle="Yes"
                      rejectTitle="No"
                    />
                  </div>
                  {/* <select className="form-control" value={form.capaStatus} name="capaStatus" onChange={onChange}>
                    <option value={""}>Select</option>
                    {!form.closed && <option value={"Open"}>Open</option>}
                    <option value={"Completed"}>Completed</option>
                  </select> */}
                  <span className="small text-danger">{errorForm.capaStatus}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500 mb-1">Completion Proof</h5>
                  <MultipleFileUpload
                    uploadLimit={1}
                    isLabel={false}
                    clsNameCustom={"col-md-12 pl-0"}
                    labelName={"Document"}
                    onFileChange={onFileChange}
                    alias={form.completionProof?.alias || ""}
                    isDisable={form.capaStatus == "Completed" ? false : true}
                    deleteDocumentFile={deleteDocumentFile}
                    selectedFileArray={form.completionProof ? [form.completionProof] : []}
                  />
                  <span className="small text-danger">{errorForm.completionProofId}</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5 className="w-500 mb-1">Completion Date</h5>
                  <DatePicker
                    name="completionDate"
                    value={form.completionDate}
                    disabled={form.capaStatus == "Completed" ? false : true}
                    onChange={(moment, name) =>
                      typeof moment !== "string" &&
                      onChange({ target: { name, value: moment.format("YYYY-MM-DD") } })
                    }
                    isValidDate={disableFutureDate}
                  />
                  <span className="small text-danger">{errorForm.completionDate}</span>
                </div>
              </Col>
              <Col lg={12}>
                <div className="form-group viewbox">
                  <h5 className="w-500 mb-1">
                    Describe Actions Taken or Resolution Provided
                  </h5>
                  <textarea
                    class="form-control h-120"
                    value={form.actionsOrResolutions}
                    name="actionsOrResolutions"
                    onChange={onChange}
                  />
                  <span className="small text-danger">
                    {errorForm.actionsOrResolutions}
                  </span>
                </div>
              </Col>
            </Row>
            {!loading ? (
              <div className="mb-2 text-center">
                {/* <Link to={(siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/capa-management/manage-capa"} className="btn btn-secondary mr-2">
                Cancel
              </Link> */}
                <Button
                  onClick={onSubmit}
                  type="submit"
                  variant="primary"
                  className="m-1 text-capitalize"
                >
                  Complete CAPA
                </Button>
              </div>
            ) : (
              <NetZeroLoader />
            )}
          </div>
        </div>
      )}
      {tab === 3 && (
        <Col lg={12} className="pt-3">
          <ViewCommentsComponent comments={capaComments ? capaComments : []} />
        </Col>
      )}
      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </div>
  );
};

export default UpdateCapa;
